import {json, JsonMappers} from '../../../../core/data-source/json.mapper';
import {ViolationRecord} from '../../../../records/violation.record';

export class OrderLogRecord {
    @json()
    id: number;

    @json()
    actionTime: string;

    @json()
    actionedBy: string;

    @json()
    etaTime: string;

    @json()
    shortDescription: string;

    @json()
    state: string;

    @json()
    fullDescription: string;

    @json(JsonMappers.ArrayOf(() => ViolationRecord))
    violations: ViolationRecord[];

    @json({
        from: (value: any, data: OrderLogRecord): string => {
            let translatedAlerts: string[] = [];
            if (data.fullDescription) {
                translatedAlerts.push(data.fullDescription);
            }
            if (data.violations) {
                data.violations.map((val) => {
                    translatedAlerts.push(val.message);
                });
            }
            return translatedAlerts.join('<br/>');
        }
    })
    violationsMessage: string;
}
